import { Input } from "antd";

export default function Search({ onSearch }) {
  return (
    <Input.Search
      placeholder="Search by Title"
      allowClear
      onSearch={onSearch}
      enterButton="Search"
    />
  );
}
